import { Box, styled, useTheme } from "@mui/material";

const SplashScreenStyled = styled("div")<{ $position: "center" | "top-right"; $backgroundColor: string }>(
  ({ $position, $backgroundColor, theme }) => `
  position: ${$position === "top-right" ? "absolute" : "fixed"};
  top: ${$position === "top-right" ? "24px" : "0"};
  right: ${$position === "top-right" ? "24px" : "0"};
  left: ${$position === "center" ? "0" : "unset"};
  bottom: ${$position === "center" ? "0" : "unset"};
  width: ${$position === "center" ? "100vw" : "auto"};
  height: ${$position === "center" ? "100vh" : "auto"};
  display: flex;
  justify-content: ${$position === "center" ? "center" : "flex-end"};
  align-items: ${$position === "center" ? "center" : "flex-start"};
  background: ${$backgroundColor};
  z-index: 9999;

  .splash-screen-spinner {
    color: ${theme.palette.primary.main};
    margin-top: 10px;
  }
`
);

export function SplashScreen({
  message = "Loading...",
  position = "center",
  backgroundColor
}: {
  message?: string;
  position?: "center" | "top-right";
  backgroundColor?: string;
}) {
  const theme = useTheme();
  // Default background: theme-aware
  const bg =
    backgroundColor ||
    (theme.palette.mode === "dark"
      ? theme.palette.background.default || "#181818"
      : theme.palette.background.default || "#fff");

  return (
    <SplashScreenStyled $position={position} $backgroundColor={bg}>
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            src="/Sellpath-logo.png"
            alt="Worksine logo"
            sx={{
              width: 50,
              height: 50,
              display: "block",
              objectFit: "contain"
            }}
          />
        </div>

        <div style={{ display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            src="/static/images/gif/spinner.gif"
            alt="loading"
            sx={{
              width: 100,
              height: 100,
              display: "block",
              objectFit: "contain"
            }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
          <span style={{ fontSize: 20, color: theme.palette.text.secondary }}>{message}</span>
        </div>
      </div>
    </SplashScreenStyled>
  );
}
